export default __webpack_public_path__ + "static/bissuh-d592a2ba1a36d1151b57d433e20c711b.jpg";